<template>

  <div>
   <el-form inline label-position="top">
     <select-sharer label="Sharer" v-model="row.organisation_id" :disabled="disabled" />
     <text-input label="Name" v-model="row.name" :disabled="disabled" />
     <check-box label="First Sharer Only" v-model="row.firstSharerOnly" :disabled="disabled" />
     <switch-input label="Rate By Sharer No" v-model="row.ratesBySharerNo" :disabled="disabled" />
     <switch-input label="Rate By Sharer Qty" v-model="row.ratesBySharerQty" :disabled="disabled" />

    <el-row :gutter="guts">

      <el-col :xs="24" :sm="24" :md="12" :lg="6">
        <number-input label="Group ID" v-model="row.groupId" :disabled="disabled" />
      </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
      <number-input label="From Sharer" :min="1" :max="10" v-model="row.fromSharer" :disabled="disabled" />
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
      <number-input label="To Sharer" :min="1" :max="10" v-model="row.toSharer" :disabled="disabled" />
    </el-col>


    <el-col :xs="24" :sm="24" :md="12" :lg="6">
      <number-input label="Height (metres)" :min="0" :max="121" v-model="row.height" :disabled="disabled" />
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
    </el-col>

    <el-col :xs="24" :sm="24" :md="12" :lg="6">
    </el-col>

    <el-row :gutter="guts">
      <hr />
      <h4>Sharer Rates</h4>
    </el-row>

    <el-row :gutter="guts">

      <el-col v-for="i in Number(row.toSharer)" :key="i" :xs="24" :sm="12" :md="6" :lg="4">
        <currency-input :label="'Rate #' + i" v-model="row['telco' + i]" :disabled="disabled" />
      </el-col>

    </el-row>

    <el-row :gutter="guts">
      <hr />
      <h4>MW &amp; RRU Rates</h4>
    </el-row>

    <el-col :span="8">
      <currency-input label="MW Rate" v-model="row.mwRate" :disabled="disabled" />
    </el-col>

    <el-col :span="8">
      <currency-input label="RRU Rate" v-model="row.rruRate" :disabled="disabled" />
    </el-col>

    <el-col :span="8">
      <number-input label="RRU Set" v-model="row.rruSet" :min="0" :max="10" :disabled="disabled" />
    </el-col>

  </el-row>

  </el-row>
</el-form>
  </div>

</template>



<script>

import NumberMixins from '@/mixins/NumberMixins'

import SelectSharer from '@/components/atoms/selects/SelectSharer'

export default {

  mixins: [NumberMixins],

  components: {
    SelectSharer
  },

  props: {
    rowData: {
      type: Object,
      default: null
    },

    editMode: {
      type: Boolean,
      default: false
    }
  },


  computed: {
    years: function () {
      this.row.years = (this.row.toMonth - this.row.fromMonth) / 12
      return this.formatNumber(this.row.years, 1)
    }
  },

  watch: {
    editMode: function (val) {
      this.disabled = val
    }
  },

  data () {
    return {
      guts: 12,
      disabled: this.editMode,
      row: this.rowData ? this.rowData : this.getTableStruct('rates')
    }

  }


}
</script>
